import _ from 'lodash';
import { mapGetters } from 'vuex';

import { loadStatus } from '@/types';
import { driversWithCDN } from '@/types/models/company';

import bookedLoadMixin from './bookedLoadMixin';
import loadGroupMixin from './loadGroupMixin';

export default {
  mixins: [
    bookedLoadMixin,
    loadGroupMixin,
  ],
  computed: {
    ...mapGetters('companies', {
      company: 'currentCompany',
    }),
    loadingDirectDispatchAssignments() {
      return this.loadingBookedLoads;
    },
    directDispatchTime() {
      return this.bookedLoadsTime;
    },
    directDispatchCompanyId() {
      return this.bookedLoadsCompanyId;
    },
    // a list of booked loads for the company with assigned drivers
    directDispatchLoadAssignments() {
      const interested = {
        [loadStatus.SCHEDULED]: true,
        [loadStatus.IN_TRANSIT]: true,
      };
      const loads = this.bookedLoads || [];
      return _.chain(loads)
        .filter(l => interested[l.loadStatus])
        .filter(l => l.tacticalInfo.truckingCompany) // OK to use trucking company here. seeking out the company's ID
        .filter(l => l.tacticalInfo.truckingCompany.id === this.directDispatchCompanyId)
        .filter(l => l.tacticalInfo.assignedTruckingCompanyDriverUserId)
        .sortBy(['tacticalInfo.assignedTruckingCompanyDriverName', 'tacticalInfo.assignedTruckingCompanyDriverUserId', 'tacticalInfo.scheduledPickupTime'], ['asc', 'asc', 'asc'])

        .value();
    },
    directDispatchDriversAwaitingAssignment() {
      const assignedEeIds = _.map(this.directDispatchLoadAssignments, l => l.tacticalInfo.assignedTruckingCompanyDriverUserId);
      const unavailableEeIds = _.map(this.directDispatchDriversUnavailable, e => e.userId);
      return _.chain(this.directDispatchDrivers)
        .reject(d => assignedEeIds.includes(d.id)) // drivers with assignment aren't waiting
        .reject(d => unavailableEeIds.includes(d.id)) // drivers unavailable aren't waiting
        .sortBy(['name', 'id'], ['asc', 'asc'])

        .value();
    },
    directDispatchDriversUnavailable() {
      return _.chain(this.directDispatchDrivers)
        .reject(e => e) // reject available employees. all are available for now.
        .value();
    },
    directDispatchDrivers() {
      return _.chain(driversWithCDN(this.company))
        .sortBy(['name', 'id'], ['asc', 'asc'])
        .value();
    },
  },
  methods: {
    loadDirectDispatchAssignments() {
      this.loadBookedLoads(this.directDispatchCompanyId);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/directDispatchingMixin.js